import { Grid, Typography } from "@material-ui/core";
import React from "react";
import { IconTooltip } from "../../icons/IconTooltip";
import { HtmlTooltipLocal, useStylesInputLocal } from "./ViewModeTextField";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";

export const EditFieldHistoryComponent = (propss: {
  auditList: any[];
  fromSettelement?: boolean;
  isNotInfo?: boolean;
}) => {
  const { auditList, fromSettelement, isNotInfo } = propss;
  const classes = useStylesInputLocal();
  function formatDate(date: any) {
    if (date) {
      const dateAndTime = new Date(date).toLocaleDateString(undefined, {
        hour12: false, //AM-101
        hour: "2-digit",
        minute: "2-digit",
        year: "numeric",
        month: "short",
        day: "2-digit"
      });
      return dateAndTime;
    }
    return "";
  }
  function nameToInitials(fullName: string) {
    if (fullName) {
      const namesArray = fullName
        .trim()
        .toUpperCase()
        .split(" ");
      if (namesArray.length === 3) {
        return namesArray[0].charAt(0) + namesArray[2].charAt(0);
      }
      if (namesArray.length === 2) {
        return namesArray[0].charAt(0) + namesArray[1].charAt(0);
      }
      return namesArray[0].charAt(0);
    }
    return "";
  }

  return (
    <>
      {auditList && auditList?.length > 0 && !isNotInfo ? (
        <div
          className={classes.editedLabel}
          style={fromSettelement ? { width: "auto" } : {}}
        >
          <div className={classes.tagTitle}>
            {fromSettelement &&
            auditList[0].updatedBy === "System Re-Calculated"
              ? "Recalc"
              : "Edited"}
          </div>
          <HtmlTooltipLocal
            placement={!fromSettelement ? "right-end" : undefined}
            // placement="right-end"
            // color="white"
            title={
              <>
                <div className={classes.container}>
                  <Grid container spacing={3} className={classes.root}>
                    <Grid item xs={12} container>
                      <Grid item xs={6} sm={12}>
                        {auditList &&
                          auditList.map((item: any, index: any) => {
                            return (
                              <div
                                key={`audit-${index}`}
                                className={classes.infoContainer}
                              >
                                <Grid
                                  item
                                  xs={1}
                                  sm={1}
                                  md={1}
                                  xl={1}
                                  style={{ display: "flex" }}
                                >
                                  {index !== auditList.length - 1 &&
                                  auditList.length !== 1 &&
                                  index < 2 ? (
                                    <span className={classes.Line} />
                                  ) : (
                                    ""
                                  )}
                                </Grid>
                                <Grid
                                  container
                                  item
                                  xs={12}
                                  sm={12}
                                  md={12}
                                  xl={12}
                                  className={
                                    index === 0 ? classes.firstEdit : ""
                                  }
                                >
                                  <span className={classes.oval}>
                                    <IconTooltip
                                      topic="Edit_white"
                                      infoIconData="edit"
                                    />
                                  </span>
                                  <Typography
                                    className={classes.title}
                                    color="textSecondary"
                                    gutterBottom
                                  >
                                    Previous Value :&nbsp;
                                    {item?.preValue === true
                                      ? "Yes"
                                      : item?.preValue === false
                                      ? "No"
                                      : typeof item?.preValue === "string" ||
                                        typeof item?.preValue === "number"
                                      ? item?.preValue
                                      : item?.preValue?.[0]}
                                  </Typography>
                                </Grid>
                                <Grid
                                  container
                                  item
                                  xs={12}
                                  sm={12}
                                  md={12}
                                  xl={12}
                                  style={{ marginTop: 0 }}
                                  className={classes.infoInnerContainer}
                                >
                                  <Grid item xs={12} sm={12} md={12} xl={12}>
                                    <Typography
                                      component="div"
                                      className={
                                        index === auditList.length - 1
                                          ? classes.title2
                                          : classes.title2
                                      }
                                      color="textSecondary"
                                      gutterBottom
                                    >
                                      Edited Value :&nbsp;
                                      {typeof item?.value === "string"
                                        ? item?.value
                                        : item?.value}
                                      <br />
                                      {!item?.comment &&
                                      item?.comments !== "null" ? (
                                        <p className={classes.reasonLabel}>
                                          Reason:&nbsp;
                                          {item?.comments}
                                        </p>
                                      ) : (
                                        ""
                                      )}
                                    </Typography>
                                    <Typography
                                      component="div"
                                      className={classes.title3}
                                      style={{
                                        position: "relative"
                                      }}
                                      color="textPrimary"
                                    >
                                      <span className={classes.initials}>
                                        {nameToInitials(item?.updatedBy)}
                                      </span>
                                      {item?.updatedBy}
                                      &nbsp;
                                      <span
                                        className={
                                          !item?.comments
                                            ? classes.latClass
                                            : classes.orgClass
                                        }
                                      >
                                        {!item?.comments ? "T" : "O"}
                                      </span>
                                      <span
                                        style={{
                                          paddingLeft: "5px"
                                        }}
                                      >
                                        {formatDate(new Date(item?.updatedOn))}
                                      </span>
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </div>
                            );
                          })}
                      </Grid>
                    </Grid>
                  </Grid>
                </div>
              </>
            }
          >
            <InfoOutlinedIcon htmlColor="white" />
          </HtmlTooltipLocal>
        </div>
      ) : null}
    </>
  );
};
